import { gql } from '@apollo/client'

import MoneyContent from '@Queries/cms/fragments/MoneyContent.fragment'

export default gql`
  ${MoneyContent}

  fragment ProductTileFragment on Product {
    id
    type
    name
    url
    primaryAsset: asset(tag: "primary") {
      url
      tags
    }
    hoverAsset: asset(tag: "hover") {
      url
      tags
    }
    availability {
      isInStock
    }
    masterVariant {
      id
      isBestSeller: attribute(key: "isBestSeller") {
        ... on BaseAttribute {
          value
        }
      }
      isNew: attribute(key: "isNew") {
        ... on BaseAttribute {
          value
        }
      }
      personalizations: attribute(key: "personalizations") {
        ... on ProductAttribute {
          productIDs
        }
      }
      price {
        ...PriceFragment
      }
    }
  }
`
